import React, {useState,useEffect,Fragment} from "react";
import localization from "assets/localization/localization";
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import '../main.css'
import Layout from 'components/sales/layout/layout';
import SiteInformationForm from 'components/fileComplain/formSection/siteInformationForm/valetFilter';
import CustomModal from "../modal";

const Supervisor = (
    {
        supervisorList, supervisorRes,siteInfo = [], deleteSupervisor, deleteSupervisorDetails
    }
) => {

    const [isLoading, setIsLoading] = useState(false);
    const [listData, setListData] = useState([]);
    const [projectId, setProjectId] = useState("");
    const [count, setCount] = useState(0)
    const [notify, setNotify] = useState("");

    const headers = ['Id', 'Name', 'Contact', 'status', 'Action'];

    useEffect(() => {
       
        const tableData = ['id', 'name', 'phone_number', 'active', 'Action'];
        if(siteInfo && siteInfo.length > 0){
            const data = siteInfo.map((element) =>{
                Object.assign(
                          {},
                          ...tableData.map((key) => ({ [key]: element[key] })),
                          
                        )
            });
            if (data) {
                setListData(data);
            }
        }
      }, [siteInfo]);
      const headerBtns = () => {
        return (
          <Fragment>
           <a
            href={`/dashboard/supervisor`}
            className="btn btn-primary d-none d-md-inline-block"
            
            >Add Supervisor</a>
          </Fragment>
        );
      };

    const handleDisable = async (id, userId) => {
        let data = {
            'project_id': projectId,
            'user_id': userId,
        }

        setIsLoading(true)
        let res = await deleteSupervisor(data)
        setNotify(res.data.response.status)
        setIsLoading(false)
        setCount(count+1)
    }

    return (
        
          <Layout title={localization.supervisorList} 
            Buttons={headerBtns}
            isLoading={isLoading}>
                <div className="row">
                    <div className="col-md-12">
                    <PanelCardWithHeading
                        title={localization.Filter}
                        isLoading={isLoading}
                            >
                            <SiteInformationForm
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                            siteInformationData={async (val) => {
                                setProjectId(val?.projectId)
                                setIsLoading(true);
                                await supervisorList(val);
                                setIsLoading(false);
                            }}
                            />
                    </PanelCardWithHeading>
                    </div>
                    <div className="col-md-12">
                
                {siteInfo && listData && siteInfo.length > 0 && (
                    <PanelCardWithHeading title={localization.supervisorList}>
                        {deleteSupervisorDetails !== {} && notify !== 200 &&
                            <CustomModal msg={deleteSupervisorDetails?.response?.message} isPageLoad={true}  click={count}/>}
                        {deleteSupervisorDetails !== {} && notify === 200 &&
                            <CustomModal msg={deleteSupervisorDetails?.response?.message}  isPageLoad={true} click={count}/>}
                        <table className="panel-table table table-bordered">
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Id</th>
                                    <th>Name</th>
                                    <th>Contact</th>
                                    <th>Active</th>
                                    <th>Date</th>
                                    <th style={{"text-align":"left"}}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {siteInfo && siteInfo.length > 0 ?
                                    <>
                                    {siteInfo.map((val,key) => {
                                        
                                        return(<tr key={{key}}>
                                            <td>{key+1}</td>
                                            <td>{val.id}</td>
                                            <td>{val.name}</td>
                                            <td>{val.phone_number}</td>
                                            <td>{val.active ?'Yes' :'No'}</td>
                                            <td>{val.created_at && val.created_at.slice(0,10)}</td>
                                            <td>
                                                <center>
                                            <button className="btn btn-sm btn-primary"
                                                    onClick={() => {handleDisable(val.id, val.user_id)}}>{val.active ? 'Disable' : 'Enable'}</button>
                                                </center>
                                            </td>
                                        </tr>);
                                    })}
                                    </>
                                : null}
                            </tbody>
                        </table>
                    </PanelCardWithHeading>
                )}
                </div>
                </div>
                
            
            </Layout>
        
    );
};

export default Supervisor
